// src/store/six-detail/thunks/createFolderThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { fetchSixDetailMetaAndFilesThunk } from '@/store/thunks/sixDetail/fetchMetaAndFilesThunk';

import {
  publishSixEvent,
} from '../poc/messaging/publishSixEventThunk';

export const createFolderThunk = createAppAsyncThunk<
  undefined,
  { sixId: string; folderName: string; folderPath: string }
>(
  'sixDetail/createFolder',
  withLoader(
    async(
      { sixId, folderName, folderPath },
      { extra, dispatch }
    ) => {
      await extra.sixDetailService.createFolder(sixId, folderName, folderPath);
      await dispatch(fetchSixDetailMetaAndFilesThunk(sixId)).unwrap();
      await dispatch(
        publishSixEvent.folderCreated({ sixId, folderName, folderPath })
      ).unwrap();
      return undefined;
    }
  )
);
